<app-page-title></app-page-title>

<app-loader [hidden]="loadingCounter === 0"></app-loader>

<div class="table-wrapper" *ngIf="dataService.isMZU()" [hidden]="loadingCounter > 0">
  <p-table [value]="distributions"
           [tableStyle]="{ 'min-width': '50rem' }"
           styleClass="p-datatable-sm"
           [scrollable]="true"
           scrollHeight="flex"
           [customSort]="true"
           [lazy]="true"
           [resizableColumns]="true"
           columnResizeMode="expand"
           [columns]="tabHeader"
           [reorderableColumns]="true"
           (onLazyLoad)="loadData($event)"
           (onColReorder)="saveColumnOrder()">

    <ng-template pTemplate="header">
      <tr>
        <th class="table-header-text table-header-bg-grey" [pSortableColumn]="column.key" *ngFor="let column of tabHeader" style="min-width: 10em" pReorderableColumn pResizableColumn>
          <div style="display: inline-block" class="flex align-items-center">
            {{ column.label }}&nbsp;
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-columns="columns">
      <tr class="table-content-text" (dblclick)="goToDistribution(row['distribution']['id'])">
        <ng-container *ngFor="let col of columns">
        <td class="h10-text black-80" *ngIf="col.key === 'lovId'">
            {{row['lovId']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'mnnId'">
          {{row['mnnId']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'id'">
          <a (click)="goToDistribution(row['id'])" style="cursor: pointer">
            {{row['distribution']['orderName']}}
          </a>
        </td>

        <td class="h10-text black-80"  *ngIf="col.key === 'orderDate'">
          {{row['distribution']['orderDate'] | date: 'dd.MM.yyyy'}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'originalAuthorName'">
          {{row['distribution']['originalAuthorName']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'status'">
          <div class="h10-text" style="display: flex; flex-direction: row; width: 18em"><img [src]="getPathToStatusImg(row['distribution']['status'])" width="4" height="16" style="vertical-align: middle;" />&nbsp; {{statusTranslatorService.getStatusForString(row['distribution']['status'])}}</div>
        </td>

        <td class="h10-text black-60" *ngIf="col.key === 'direction'">
          <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipContent">
                            {{row['direction']['shortName']}}
                        </span>
          </div>
          <ng-template #tooltipContent>
            <div class="flex items-center h10-text">
              {{row['direction']['name']}}
            </div>
          </ng-template>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'subDirection'">
          <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipSubDirection">
                            {{row['subDirection']}}
                        </span>
          </div>
          <ng-template #tooltipSubDirection>
            <div class="flex items-center h10-text">
              {{row['subDirection']}}
            </div>
          </ng-template>
        </td>

        <td *ngIf="col.key === 'signs'">
          <div class="flex">
          <med-bubble
            [styleClass]="'med-bubble-dark-purple'">
            <div class="h10-text">
              <span style="color: #fff">12</span>
              <span style="color: #c7c7c7">/12</span>
            </div>
          </med-bubble>
          (m)
          </div>
        </td>

        <td class="h10-text" *ngIf="col.key === 'agreementNumber'">
          <a href="#">1231231_1231</a> (m)
        </td>

        <td *ngIf="col.key === 'mnn'">
          <div class="flex-12rem" *ngIf="col.key === 'mnn'">
                        <span class="truncate-text" [pTooltip]="tooltipMnn">
                          {{row.mnnName}}
                        </span>
          </div>
          <ng-template #tooltipMnn >
            <div class="flex items-center h10-text">
              {{row.mnnName}}
            </div>
          </ng-template>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'dosage'">
          {{row['dosage']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'tradeName'">
          <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipTradeName">
                          {{row.tradeName}}
                        </span>
          </div>
          <ng-template #tooltipTradeName >
            <div class="flex items-center h10-text">
              {{row['tradeName']}}
            </div>
          </ng-template>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'distributedQuantity'">
          {{row['quantity']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'measure'">
          {{row['unit']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'unitPrice'">
          {{row['cost']}}
        </td>

        <td class="h10-text black-80"  *ngIf="col.key === 'totalPrice'">
          {{row['totalCost']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'pdv'">
          {{ getVatRate(row['vatRate'])}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'totalPriceWithPDV'">
          {{row['totalCostVat']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'deliveredQuantity'">
          {{row['quantityDistributed']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'totalDeliveredPriceWithPDV'">
          15307,00 (m)
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'deliveredAndDistributed'">
          <p-progressBar aria-labelledby="label_status2" [value]="50"></p-progressBar>
          <div id="label_status2" class="h10-text flex flex-between">
            <div>
              16/32
            </div>
            <div>
              50%
            </div>
          </div>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'warehouseName'">
          {{row['distribution']['warehouseName']}}
        </td>

        <td class="h10-text black-80" *ngIf="col.key === '4'">
          <div class="h10-text" style="display: inline-flex"><img [src]="getPathToStatusImg('iNeedGreen')" width="4" height="16" style="vertical-align: middle;"/>&nbsp; Ні</div>
        </td>

        <td class="h10-text black-80" *ngIf="col.key === 'until'">
          13.06.2025
        </td>
      </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="flex flex-center flex-between">
        <med-pagination
          [total]="totalRows"
          [page]="selectedPageNumber"
          [perPage]="pageSize"
          (pageChange)="pageChange($event)"
        ></med-pagination>

        <div class="small-text">
          Показано &nbsp;<strong>{{ getFirstShowedRowIndex() }}</strong>-<strong>{{ getFirstShowedRowIndex() + pageSize }}</strong> &nbsp;з {{ totalRows }}
        </div>

        <div>
          <span class="small-text">Кількість на сторінку</span>
          <med-radio-group
            mode="buttons"
            [value]="totalRows"
            [options]="paginationOptions"
            (onInput)="pageSizeChanged($event)"
          ></med-radio-group>
        </div>
      </div>
    </ng-template>

  </p-table>
</div>
